const TOOLTIP_SELECTOR = '[data-bs-toggle="tooltip"]';

export function initTooltips(root = document) {
    const {Tooltip} = window.bootstrap || {};
    if (!Tooltip || !root) return;

    root.querySelectorAll(TOOLTIP_SELECTOR).forEach((el) => {
        if (el.dataset.bsTitle && !el.hasAttribute('title')) {
            el.setAttribute('title', el.dataset.bsTitle);
        }

        if (!Tooltip.getInstance(el)) {
            const opts = {
                trigger: el.dataset.bsTrigger || 'hover focus',
                container: el.dataset.bsContainer || 'body',
                placement: el.dataset.bsPlacement || 'top',
                html: el.dataset.bsHtml === 'true',
            };
            new Tooltip(el, opts);
        }
    });
}

export function disposeTooltips(root = document) {
    const {Tooltip} = window.bootstrap || {};
    if (!Tooltip || !root) return;

    root.querySelectorAll(TOOLTIP_SELECTOR).forEach((el) => {
        Tooltip.getInstance(el)?.dispose();
    });
}

export function registerTooltips() {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => initTooltips(document), {once: true});
    } else {
        initTooltips(document);
    }

    document.addEventListener('turbo:load', () => initTooltips(document));
    document.addEventListener('turbo:frame-load', (e) => initTooltips(e.target));
    document.addEventListener('turbo:before-cache', () => disposeTooltips(document));
}
